(function () {
  const MODAL_SELECTOR = '#SocialQrModal';
  const TRIGGER_SELECTOR = '.social-qr-trigger';
  const GAP = 10;
  const VIEWPORT_PADDING = 10;

  function getModal() {
    return document.querySelector(MODAL_SELECTOR);
  }

  function positionDialog(trigger, dialog) {
    const triggerRect = trigger.getBoundingClientRect();
    const dialogWidth = dialog.offsetWidth;
    const dialogHeight = dialog.offsetHeight;
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    let top = triggerRect.top - dialogHeight - GAP;
    let left = triggerRect.right - dialogWidth;

    if (top < VIEWPORT_PADDING) {
      top = triggerRect.bottom + GAP;
    }

    if (left < VIEWPORT_PADDING) {
      left = triggerRect.left;
    }

    left = Math.max(
      VIEWPORT_PADDING,
      Math.min(left, viewportWidth - dialogWidth - VIEWPORT_PADDING)
    );
    top = Math.max(
      VIEWPORT_PADDING,
      Math.min(top, viewportHeight - dialogHeight - VIEWPORT_PADDING)
    );

    dialog.style.top = `${top}px`;
    dialog.style.left = `${left}px`;
  }

  function initSocialQrModal() {
    const modal = getModal();
    if (!modal || modal.dataset.initialized === 'true') return;

    const overlay = modal.querySelector('[data-social-qr-overlay]');
    const dialog = modal.querySelector('[data-social-qr-dialog]');
    const image = modal.querySelector('[data-social-qr-image]');
    const closeButtons = modal.querySelectorAll('[data-social-qr-close]');

    let activeTrigger = null;

    const isOpen = () => modal.classList.contains('is-open');

    const reposition = () => {
      if (!activeTrigger || !dialog || !isOpen()) return;
      positionDialog(activeTrigger, dialog);
    };

    const open = (trigger) => {
      const imageUrl = trigger.dataset.qrImage;
      const platformName = trigger.dataset.platform || '';

      if (!imageUrl) return;

      activeTrigger = trigger;

      if (image) {
        image.src = imageUrl;
        image.alt = platformName;
      }

      if (dialog && platformName) {
        dialog.setAttribute('aria-label', platformName);
      }

      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('is-open');

      requestAnimationFrame(() => {
        reposition();

        if (image && !image.complete) {
          image.addEventListener('load', reposition, { once: true });
        }
      });
    };

    const close = () => {
      activeTrigger = null;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');

      window.setTimeout(() => {
        if (!modal.classList.contains('is-open')) {
          modal.setAttribute('hidden', '');

          if (image) {
            image.removeAttribute('src');
          }

          if (dialog) {
            dialog.style.removeProperty('top');
            dialog.style.removeProperty('left');
          }
        }
      }, 200);
    };

    const onDocumentClick = (event) => {
      const trigger = event.target.closest(TRIGGER_SELECTOR);

      if (trigger) {
        event.preventDefault();
        event.stopPropagation();

        if (isOpen() && activeTrigger === trigger) {
          close();
          return;
        }

        open(trigger);
        return;
      }

      if (!isOpen()) return;

      if (dialog && !dialog.contains(event.target)) {
        close();
      }
    };

    const onKeydown = (event) => {
      if (event.key === 'Escape' && isOpen()) {
        close();
      }
    };

    document.addEventListener('click', onDocumentClick, true);
    document.addEventListener('keydown', onKeydown);
    window.addEventListener('resize', reposition);
    window.addEventListener('scroll', reposition, true);

    closeButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        close();
      });
    });

    overlay?.addEventListener('click', close);

    modal.dataset.initialized = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSocialQrModal);
  } else {
    initSocialQrModal();
  }

  document.addEventListener('shopify:section:load', initSocialQrModal);
})();
